import React from 'react'
import { Spin } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../../actions'

import stripeCheckoutRedirectHTML from '../../../common/StripeCheckout'

const PaymentPage = () => {
  const dispatch = useDispatch()

  const { checkoutSessionId, stripePublicKey } = useSelector(
    state => state.payment
  )

  if (!checkoutSessionId || !stripePublicKey) {
    dispatch(Actions.createAction(Actions.REDIRECT_TO_PAYMENT_CANCEL))
  } else {
    const htmlString = stripeCheckoutRedirectHTML(
      checkoutSessionId,
      stripePublicKey
    )

    return (
      <iframe
        allowfullscreen={true}
        allowpaymentrequest={true}
        frameborder="0"
        srcdoc={htmlString}
        sandbox="allow-scripts allow-same-origin allow-top-navigation "
      ></iframe>
    )
  }
  return <Spin size="large" />
}

export default PaymentPage
